<div>
  <div [formGroup]="form">

    <div class="controls">
      <div>
        <app-indicator-select [value]="form.value.type ? form.value.type['value'] : null"
                              [simpleMode]="true"
                              (changed)="indicatorChanged($event)"
        ></app-indicator-select>

        <!--mat-form-field class="width100">
        <mat-label>Параметр</mat-label>
          <!--input matInput type="text" formControlName="type" [matAutocomplete]="autoVal" [autofocus]="false">
          <mat-autocomplete #autoVal="matAutocomplete" panelWidth="auto" [displayWith]="displayFn">
            <mat-option *ngFor="let option of filteredValues | async" [value]="option" [matTooltip]="option.name">
              {{option.name}}
            </mat-option>
          </mat-autocomplete>

        <ng-template #noBoolRef>
          <input matInput type="text" formControlName="type">
        </ng-template>
      </mat-form-field-->
      </div>

      <div>
        <mat-form-field class="width100">
          <mat-label>Оператор</mat-label>
          <mat-select formControlName="op">
            <mat-option *ngFor="let op of ops"
                        (click)="opSelected(op.v, true)"
                        [value]="op.v">
              {{op.name}}
            </mat-option>
          </mat-select>
        </mat-form-field>
      </div>

      <div formArrayName="vals" class="values">
        <div *ngFor="let val of vals.controls; let i=index" class="value">
          <div [formGroupName]="i">
            <mat-form-field>
              <mat-label>{{ val.value.n }}</mat-label>
              <input matInput type="text" formControlName="v">
            </mat-form-field>
          </div>
        </div>
      </div>
      <div class="min-max-values">
        <div class="value">Минимум: {{ min | number }}</div>
        <div class="value">Максимум: {{ max | number }}</div>
      </div>
    </div>
  </div>

    <div>
      <div class="button_wrap" [matTooltip]="form.invalid ? 'Для сохранения выберите параметр, оператор и значение' : ''">
      <button mat-raised-button
              color="primary"
              [disabled]="form.invalid"
              (click)="complete()">{{ buttonLabel }}
      </button>
    </div>
  </div>
</div>
